import alt from 'components/Dispatcher';
import {List, Map} from 'immutable';
import immutableStore from 'alt-utils/lib/ImmutableUtil';
import FileUploadScorecardSource from 'sources/scorecards/FileUploadScorecardSource';
import ScorecardQuestionnaireActions from 'actions/scorecards/ScorecardQuestionnaireActions';
import FileUploadScorecardActions from 'actions/scorecards/FileUploadScorecardActions';

/**
 * Stores in-session answers from a user to the questions in a questionnaire
 */
@immutableStore
class ScorecardQuestionnaireStore {
  constructor() {
    this.state = Map({isSaving: false, isEditing: false});
    this.bindActions(ScorecardQuestionnaireActions);
    this.bindActions(FileUploadScorecardActions);
    this.registerAsync(FileUploadScorecardSource);
  }

  onAddAnswer([modelId, scorecardId, questionId, answer]) {
    const path = ['answers', modelId, scorecardId, questionId];
    this.setState(this.state.setIn(path, answer));
  }

  onRemoveAnswer([modelId, scorecardId, questionId]) {
    const path = ['answers', modelId, scorecardId, questionId];
    this.setState(this.state.deleteIn(path));
  }

  onAddComment([modelId, scorecardId, questionId, comment, taggedUsers]) {
    const path = ['comments', modelId, scorecardId, questionId];
    const taggedUsersPath = ['taggedUsers', modelId, scorecardId, questionId];
    this.setState(this.state.setIn(path, comment).setIn(taggedUsersPath, taggedUsers || List()));
  }

  onRemoveComment([modelId, scorecardId, questionId]) {
    const path = ['comments', modelId, scorecardId, questionId];
    const taggedUsersPath = ['taggedUsers', modelId, scorecardId, questionId];
    this.setState(this.state.deleteIn(path).deleteIn(taggedUsersPath));
  }

  onAddReason([modelId, scorecardId, questionId, reason]) {
    const path = ['reasons', modelId, scorecardId, questionId];
    this.setState(this.state.setIn(path, reason));
  }

  onClearAnswers([modelId, scorecardId]) {
    this.setState(
      ['answers', 'comments', 'reasons']
        .reduce((state, prop) => state.deleteIn([prop, modelId, scorecardId]), this.state)
        .set('isEditing', false)
    );
  }

  beginEditing() {
    this.setState(this.state.set('isEditing', true));
  }

  submitScorecardResultsLoading() {
    this.setState(this.state.set('isSaving', true));
  }

  onSubmitScorecardResultsSuccess() {
    this.setState(this.state.merge({isSaving: false, isEditing: false}));
  }

  clearState() {
    this.setState(Map({isSaving: false, isEditing: false}));
  }
}

export default alt.createStore(ScorecardQuestionnaireStore, 'ScorecardQuestionnaireStore');
